import { NavBarLink } from '@common/components/layout/nav/NavBarLink';
import { useApp, useCurrentMatchRoutes } from '@common/hooks';
import { CacheUtils } from '@common/utils/cacheUtils';
import { useQueryClient } from "@tanstack/react-query";
import { observer } from 'mobx-react';
import React, { useRef, useState } from 'react';
import { Nav, Overlay, Popover } from 'react-bootstrap';
import Skeleton from 'react-loading-skeleton';
import { NavLink } from 'react-router-dom';

export interface INavBarProfileProps {
    userId: number,
    userInitials: string,
    firstName: string,
    lastName: string
}

const NavBarProfile = observer(({ userId, userInitials, firstName, lastName }: INavBarProfileProps) => {
    const { isConfigurationLoading } = useApp();
    const routeMatches = useCurrentMatchRoutes();
    const queryClient = useQueryClient();

    let currentDirectory = '';
    if (routeMatches !== undefined && routeMatches.length > 1) {
        currentDirectory += (routeMatches[1].pathname != ""
            && routeMatches[1].pathname !== "/"
            && routeMatches[1].pathname != "myprofile"
            && routeMatches[1].pathname != "login")
            ? routeMatches[1].pathname : "";
    }

    let profileLink = currentDirectory + '/myprofile/' + userId;

    const [show, setShow] = useState(false);
    const target = useRef(null);

    const showOverlay = () => {
        setShow(!show);
    };

    const Logout = () => {
        window.location.href = '/account/logout';
    }

    const ClearDataCache = () => {
        CacheUtils.evictExpiredKeys(0)
            .then(() => window.alert("Data cache cleared."));

        // Clear client-side catched data
        queryClient.clear();
    }

    return (
        <Nav className="ms-auto mb-2 mb-lg-0">
            <Nav.Item onClick={() => showOverlay()}>
                {
                    isConfigurationLoading
                        ? <Skeleton circle={true} height={50} width={50} />
                        : <div>
                            <div ref={target} className="nav-link primary loggedInUserMenu"><span>{userInitials}</span></div>
                            <Overlay
                                show={show}
                                target={target.current}
                                placement="bottom"
                                container={target}
                                rootClose
                                onHide={() => setShow(false)}
                            >
                                <Popover id="popover-contained">
                                    <Popover.Body>
                                        <div className="profile-nav">
                                            <Nav.Item>
                                                <NavLink to={`${profileLink}`}>
                                                    <div className="profileIcon" />
                                                </NavLink>
                                            </Nav.Item>

                                            <NavBarLink className="nav-item-primary"
                                                name={firstName + " " + lastName}
                                                route={`${profileLink}`} />

                                            <hr style={{ margin: "0" }} />

                                            <div className="nav-item-single" onClick={() => ClearDataCache()}> Clear Data Cache</div>
                                            <div className="nav-item-single" onClick={() => Logout()}> Log out</div>
                                        </div>
                                    </Popover.Body>
                                </Popover>
                            </Overlay>
                        </div>
                }
            </Nav.Item>
        </Nav >
    );
});

export default NavBarProfile;
